import React, { useState, useEffect } from 'react';

import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Checkbox from '@material-ui/core/Checkbox';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import TextInput from 'app/components/TextInput';
import TextEvents from '../TextEvents';
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from '@material-ui/core/Tooltip'
import Chip from '@material-ui/core/Chip';
import { useStyles, styles } from './EditEvaluationStyles';
import { Modal, Select, Input, Radio, Icon, Form, Button, Upload, message } from 'antd';

import SubdirectionsContainer from 'app/containers/SubdirectionsContainer';
import ApiService from 'app/services/ApiService'
import { fetchTest, clearTest, clearTestFilter, fetchTestFilters } from 'app/actions/TestActions';
import { getTrainingSelect } from "app/actions/TrainingActions";
import { useDispatch, useSelector } from 'react-redux';

const { TextArea } = Input;
const { confirm } = Modal;


export default function EditEvaluation(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { siteId } = useSelector(state => state.Auth);

    const [name, setName] = useState('');
    const [advance, setAdvance] = useState('');
    const [description, setDesc] = useState('');
    const [subdir, setSubdir] = useState([]);
    const [defaultSubdir, setDefaultSubdir] = useState();
    const [open, setOpen] = useState(false);
    const [isTest, setTestStatus] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const [questions, setQuestions] = useState([]);
    const [id, setId] = useState();
    const [folio, setFolio] = useState('');
    const [estatus, setEstatus] = useState();
    const [time, setTime] = useState([]);
    const [typeQuestion, setTypeQuestion] = useState();
    const [isLoadedForm, setLoadForm] = useState(false);
    const [isLoadedQuestions, setLoadQuestion] = useState(false);
    const [idTraining, setIdTraining] = useState(undefined);
    const [modal2Visible, setModal2Visible] = useState(false);

    let Actual = [];
    let answers = [];
    let isReady = false;
    let emptyOptions = {};
    let isReadyOptions = false;
    let Btext = 'Incompleta';
    let isSelected = {};
    let minTwo = {};

    const { Dragger } = Upload;

    const [state_, setState_] = useState({
        fileList: [],
        finishedOrError: false,
        uploading: false,
    })

    const { uploading, fileList } = state_;
    const actions = {
        multiple: false,
        onRemove: file => {
            setState_(state => {
                const index = state_.fileList.indexOf(file);
                const newFileList = state_.fileList.slice();
                newFileList.splice(index, 1);
                return {
                    fileList: newFileList,
                };
            });
        },
        beforeUpload: file => {
            setState_(state => ({
                fileList: [...state_.fileList, file],
            }));
            return false;
        },
        fileList,
    };


    const uploadFile = async () => {
        const { fileList } = state_;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file);
        });

        setState_({
            uploading: true,
        });

        await ApiService.postTestTemplate(formData, props.editParam.idTest)
            .then(response => {
                setState_({
                    uploading: false,
                });

                Modal.success({
                    title: `Preguntas guardadas correctamente.`,
                    content: response.testTitle,
                }, props.setTab('1'));
                setModal2Visible(false)

                dispatch(clearTest());
                dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                dispatch(clearTestFilter());
                dispatch(fetchTestFilters(idSubdirection, employeeId));

            })
            .catch(error => {
                let { data } = error.response;
                Modal.error({
                    title: 'Ops, ocurrio un error.',
                    content: `${data.message}`,
                });

                setState_(state => ({
                    fileList: [],
                    finishedOrError: false,
                    uploading: false,
                }));
            })
    }

    const {
        employeeId,
        idSubdirection
    } = useSelector(state => state.Auth.employeeById)

    useEffect(() => {
        setSubdir([{
            idSubdirection: idSubdirection,
            subdirectionName: "",
            deleted: false
        }])
        dispatch(getTrainingSelect(employeeId));

    }, [dispatch])

    const {
        trainingSelect
    } = useSelector(state => state.TrainingReducer)

    const optionTraining = trainingSelect.map((item) =>
        <Select.Option key={item.key} value={item.key}>{item.value}</Select.Option>);


    useEffect(() => {
        if (name !== '') setLoadForm(true);
        if (questions.length > 0) setLoadQuestion(true);

        if (name === '' && !isLoadedForm) {
            setName(props.editParam.testTitle);
            setDesc(props.editParam.testDescription)
            setId(props.editParam.idTest);
            setFolio(props.editParam.testFolio);
            setEstatus(props.editParam.statusName);
            setDefaultSubdir(props.editParam.subdirectionName)
            setTime(props.editParam.testDuration)
            setSubdir([{ idSubdirection: parseInt(props.editParam.idSubdirection, 10), subdirectionName: props.editParam.subdirectionName }])
        }

        if (questions.length === 0 && !isLoadedQuestions) {
            setQuestions(props.questions)
        }

        if (questions.length > 0 && typeof selectedIndex === 'undefined') {
            setSelectedIndex(questions.length - 1)
            setOpen(true);
        }

        if (typeQuestion === undefined && selectedIndex !== undefined) setTypeQuestion(questions[selectedIndex].idQuestionType)
        if (idTraining === undefined) setIdTraining(props.editParam.idTraining);


    })



    const showConfirm = (type) => {
        confirm({
            title: '¿Guardar Evaluación?',
            content: name,
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                let ids = subdir.map(i => i.idSubdirection);
                return ApiService.setTest({ testTitle: name, testDescription: description, idTraining: idTraining, listSubdirection: ids, idTest: id, TestTotalQuestion: 5, testDuration: time }, 'PUT')
                    .then(
                        response => {
                            confirm({
                                title: 'Evaluación guardada correctamente.',
                                content: '¿Seguir Editando?',
                                okText: 'Continuar',
                                cancelText: 'Salir',
                                onOk() {
                                    setTestStatus(true);
                                    setOpen(true);
                                    if (questions.length === 0) {
                                        addQuestion();
                                    }
                                },
                                onCancel() {
                                    dispatch(clearTest());
                                    dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                                    dispatch(clearTestFilter());
                                    dispatch(fetchTestFilters(idSubdirection, employeeId));
                                    props.setTab('1')
                                },
                            });
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const showSecondaryConfirm = () => {
        confirm({
            title: '¿Guardar pregunta(s)?',
            okText: 'Guardar',
            cancelText: 'Cancelar',
            onOk() {
                return ApiService.setTestQuestionAnswer({ idTest: props.editParam.idTest, questions }, 'PUT')
                    .then(
                        response => {
                            dispatch(clearTest());
                            dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
                            dispatch(clearTestFilter());
                            dispatch(fetchTestFilters(idSubdirection, employeeId));
                            Modal.success({
                                title: `Preguntas guardadas correctamente.`,
                                content: response.testTitle,
                            }, props.setTab('1'));
                        }, error => {
                            Modal.error({
                                title: 'Ops, error de conexión',
                                content: 'Se perdió la conexión de red, intente más tarde.',
                            });
                        }
                    )
            },
            onCancel() { },
        });
    }

    const removeQuestion = (i) => {
        const newQuestions = [...questions];
        let desc = newQuestions[i].questionDescription;
        confirm({
            title: 'Eliminar pregunta',
            content: desc,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                if (newQuestions.length > 0) {
                    if (typeof newQuestions[i].idQuestion !== 'undefined') ApiService.removeQuestions(newQuestions[i].idQuestion);
                    newQuestions.splice(i, 1);
                    const key = newQuestions.length - 1;
                    setSelectedIndex([key]);
                    newQuestions[key] !== undefined ? newQuestions[key].activeKey.isActive = true : closeAll();
                    setQuestions(newQuestions);
                } else {
                    setOpen(false);
                    setTestStatus(false);
                }
            },
            onCancel() {
            },
        });

    }
    const closeAll = () => {
        setOpen(false);
        setTestStatus(false);
        dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
    }

    const findSubdir = (params, item) => {
        let temp = [];
        params.subdirs.forEach(v => {
            if (String(v.idSubdirection) === item.key) temp.push(v);

        });
        setSubdir(temp);
    }

    const addQuestion = () => {
        const key = questions.length <= 0 ? 0 : questions.length;
        questions.find(i => {
            return i.activeKey.isActive = false;
        });
        let question = [...new Set(questions.concat({
            questionDescription: '',
            idQuestionType: 1,
            isEvaluative: false,
            listAnswers: [
                { id: 0, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false },
                { id: 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false }
            ],
            activeKey: { isActive: true, key: key }
        }))];
        setQuestions(question);
        setSelectedIndex([key]);
        setTestStatus(true);
        setOpen(true);
    }

    const selectedQuestion = (quiz, param, i) => {
        setTestStatus(true)
        setSelectedIndex(undefined)
        const isQuiz = Array.isArray(quiz);
        const typeSelected = typeof param;
        if (isQuiz && typeSelected === 'undefined') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[quiz.length - 1].activeKey.isActive = true;
            setSelectedIndex(quiz.length - 1);
        } else if (typeSelected === 'object') {
            questions.find(i => {
                return i.activeKey.isActive = false;
            });
            questions[i].activeKey.isActive = true;
            setSelectedIndex(i)
        }
    }

    const generateQuestionList = () => {
        const descriptions = questions.find(i => {
            return i.questionDescription === '';
        })
        const answ = questions.find(i => {
            return i.listAnswers.length === 0;
        })
        if (descriptions === undefined && answ === undefined) {
            isReady = true
        }
        return questions.map((param, i) => (

            <ListItem button className={classes.nested} selected={param.activeKey.isActive} onClick={() => selectedQuestion(questions, param, i)} key={i}>
                <ListItemIcon>
                    <IconButton edge="end" aria-label="delete" className={classes.icon}>
                        <Icon type="file" style={param.questionDescription === '' ? { color: '#f50057' } : { color: 'inherit' }} />
                    </IconButton>
                </ListItemIcon>
                <Badge className={param.questionDescription !== '' ? classes.marginOptions : classes.margin} badgeContent={param.questionDescription !== '' ? 'Agregar opcion' : Btext} children={''} color='secondary'
                    invisible={param.questionDescription !== '' && param.listAnswers.length >= 2}
                />

                {param.listAnswers.map(i => {
                    return (
                        <Badge key={i.idAnswer} className={classes.marginOptions} badgeContent={'Completar opciones'} children={''} color='secondary'
                            invisible={i.descriptionAnswer !== '' || param.questionDescription === ''}
                        />)
                })
                }

                <ListItemText secondary={param.questionDescription} />

                {
                    siteId === 'HUB' ?
                        <ListItemSecondaryAction>
                            {estatus === 'ASIGNADO' ?
                                <IconButton edge="end" onClick={() => removeQuestion(i)} aria-label="delete" disabled={questions.length <= 10}>
                                    <Icon type="delete" style={questions.length <= 10 ? styles.addButtonDisabled : styles.addButton} />
                                </IconButton> :
                                <IconButton edge="end" onClick={() => removeQuestion(i)} aria-label="delete">
                                    <Icon type="delete" style={styles.addButton} />
                                </IconButton>
                            }
                        </ListItemSecondaryAction> : null
                }


            </ListItem>

        ))
    }

    //quiz methods
    const onChangeQuestion = (value) => {
        questions[selectedIndex].questionDescription = value.target.value;
        setQuestions([...questions])
    }

    const changeText = (val, id, i) => {
        const quest = [...questions];
        quest[selectedIndex].listAnswers[i].descriptionAnswer = val;
        setQuestions(quest);
    }

    const changeOptions = (param, index, type) => {
        const quest = [...questions]
        if (questions[selectedIndex].idQuestionType === 1) {
            questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            if (quest[selectedIndex].listAnswers[index] !== undefined) {
                quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
                setQuestions(quest)
            }
        } else if (index === 0 && param === 1) {
            questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
            setQuestions(quest)
        } else if (type === 'remove') {
            if (questions[selectedIndex].listAnswers.length === 1) {
                quest[selectedIndex].listAnswers[0].isCorrect = true;
                setQuestions(quest);
            }
            return null;
        } else {
            if (questions[selectedIndex].listAnswers.length === 1) {
                questions[selectedIndex].listAnswers.map(i => i.isCorrect = false)
            }
            quest[selectedIndex].listAnswers[index].isCorrect = !quest[selectedIndex].listAnswers[index].isCorrect;
            setQuestions(quest);
        }
    }

    const removeClick = (i) => {
        isReadyOptions = false;
        const newOptions = [...questions];
        newOptions[selectedIndex].listAnswers.splice(i, 1);
        setQuestions(newOptions);
        changeOptions(typeQuestion, 0, 'remove');
    }


    const addOptions = (data) => {
        Actual = [...data];
        const index = Actual[selectedIndex].listAnswers.length;
        if (questions[selectedIndex].listAnswers.length === 0) {
            answers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false });
            Actual[selectedIndex].listAnswers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: true, isApplyComment: false });
            // Object.values(Actual)
            setQuestions(Actual);
        } else {
            answers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false });
            Actual[selectedIndex].listAnswers.push({ id: index + 1, type: 'radio', descriptionAnswer: '', checked: false, isCorrect: false, isApplyComment: false });
            // Object.values(Actual)
            setQuestions(Actual);

        }
    }

    const addOptionButton = () => {
        return (
            siteId === 'HUB' ?
                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px' }}>
                    <Button type="primary" onClick={() => addOptions(questions)} >
                        <Icon type="plus" /> Agregar opción
                    </Button>
                </Form.Item>
                :
                null
        )
    }

    const createTextArea = () => {
        return (
            selectedIndex >= 0 ? <TextArea
                disabled={siteId !== 'HUB'}
                value={questions[selectedIndex].questionDescription}
                onChange={e => onChangeQuestion(e, selectedIndex)}
                autosize={{ minRows: 4, maxRows: 5 }}
            /> : '')
    }

    const createOptions = () => {
        const isIndex = typeof selectedIndex !== 'undefined';
        return isIndex ? <Radio.Group className={classes.radioContent}>
            {questions[selectedIndex].listAnswers.map((param, i) => {
                return (
                    <div className={classes.flex} key={i}>
                        <Radio style={styles.radioStyle} value={param.id} disabled />
                        <Input
                            disabled={siteId !== 'HUB'}
                            maxLength={1000}
                            id={String(param.id)}
                            value={param.descriptionAnswer}
                            onChange={(e) => changeText(e.target.value, questions[selectedIndex], i)}
                            placeholder='Escribe una opción'
                            className={classes.inputSelect}
                        />
                        {
                            questions[selectedIndex].listAnswers.length === 1
                                ?
                                <div className={classes.dynamicDeleteButton} />
                                :
                                siteId === 'HUB'
                                    ?
                                    <Tooltip title="Eliminar" placement="top">
                                        <IconButton aria-label="delete" onClick={(k) => removeClick(i)}>
                                            <Icon
                                                className={classes.dynamicDeleteButton}
                                                type="minus-circle-o"
                                                styles={{ marginRight: '2%' }}
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    :
                                    null
                        }

                        <FormGroup >
                            <FormControlLabel
                                disabled={siteId !== 'HUB'}
                                control={
                                    <Tooltip title="Correcta" placement="top"><Checkbox
                                        style={{ marginLeft: siteId !== 'HUB' ? '8px' : '' }}
                                        icon={<Icon type="check" />}
                                        checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                        value="checkedH"
                                        checked={param.isCorrect}
                                        className={classes.checkRoot}
                                        onChange={() => changeOptions(param, i)}
                                    /></Tooltip>
                                }
                                label={param.isCorrect ? 'Respuesta correcta' : ''}
                            />
                        </FormGroup>
                    </div>
                )
            }
            )}
        </Radio.Group> : '';

    }

    const createCheck = (opt) => {
        return questions[selectedIndex].listAnswers.map((item, i) => (
            <div className={classes.radioContent} key={i}>
                <div className={classes.flex} >
                    <Checkbox
                        icon={<Icon type="border" fontSize="small" />}
                        checked={item.checked}
                        value={item.id}
                        color="primary"
                        className={classes.root}
                        disabled
                    />
                    <Input
                        maxLength={1000}
                        id={String(item.id)}
                        value={item.descriptionAnswer}
                        onChange={(e) => changeText(e.target.value, item.id, i)}
                        placeholder='Escribe una opción'
                        className={classes.inputSelect}
                    />
                    {questions[selectedIndex].listAnswers.length === 1 ? <div className={classes.dynamicDeleteButton} /> : <Tooltip title="Eliminar" placement="top"><IconButton aria-label="delete" onClick={(k) => removeClick(i)}>
                        <Icon className={classes.dynamicDeleteButton}
                            type="minus-circle-o"
                            styles={{ marginRight: '2%' }}

                        />
                    </IconButton>
                    </Tooltip>}
                    <FormGroup >
                        <FormControlLabel
                            control={
                                (<Tooltip title="Correcta" placement="top"><Checkbox
                                    icon={<Icon type="check" />}
                                    checkedIcon={<Icon type="check" className={classes.successIcon} />}
                                    value="checkedH"
                                    checked={item.isCorrect}
                                    className={classes.checkRoot}
                                    onChange={() => changeOptions(item, i)}
                                /></Tooltip>)
                            }
                            label={item.isCorrect ? 'Respuesta correcta' : ''}
                        />
                    </FormGroup>
                </div>
            </div>
        ))
    }
    const onChangeRadioGroupType = (e) => {
        const quest = [...questions];
        quest[selectedIndex].idQuestionType = e;
        setQuestions(quest);
    }
    const createTypeButtons = () => {
        return (
            siteId === 'HUB' ?
                <Radio.Group value={questions[selectedIndex].idQuestionType} onChange={(e) => onChangeRadioGroupType(e.target.value)} style={{ width: '100%', marginBottom: 16 }}>
                    <Radio.Button value={1} onClick={() => changeOptions(1, 0)}>Simple</Radio.Button>
                    <Radio.Button value={2} onClick={() => changeOptions(2, 0)}>Múltiple</Radio.Button>
                </Radio.Group>
                : null
        )
    }

    const testStatus = () => {
        setTestStatus(false)
        questions[selectedIndex].activeKey['isActive'] = false;
    }

    const onChangeNumber = e => {
        const { value } = e.target;
        const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
        if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
            const val = value.replace(/[^0-9]*/g, '');
            setTime(val)
        }
    };

    questions.forEach(i => {
        emptyOptions = i.listAnswers.find(i => i.descriptionAnswer === '');
        if (i.listAnswers.length > 0) isSelected = i.listAnswers.find(i => i.isCorrect === true)
    });
    minTwo = questions.find(i => i.listAnswers.length === 1);
    if (emptyOptions === undefined && isSelected !== undefined && minTwo === undefined) {
        isReadyOptions = true
    } else if (typeQuestion === 2 && isSelected === undefined) {
        isReadyOptions = false
    } else {
        isReadyOptions = false
    }

    if (questions[selectedIndex] !== undefined) {
        if (questions[selectedIndex].idQuestionType === 2) {
            const total = questions[selectedIndex].listAnswers.filter(i => i.isCorrect === true)
            if (total.length < 2) {
                isReadyOptions = false
            }
        }

    }

    return (
        <div>
            <Modal
                title="Cargar preguntas por template"
                closable
                destroyOnClose
                visible={modal2Visible}
                onOk={() => uploadFile()}
                onCancel={() => setModal2Visible(false)}
                okButtonProps={{ disabled: fileList?.length == 0, loading: uploading }}
            >

                <Upload {...actions} disabled={siteId !== 'HUB'} accept={'.xlsx'} >
                    <Button>
                        <Icon type="upload" /> Seleccione el archivo...
                    </Button>
                </Upload>
            </Modal>
            <Grid container direction="row">
                <Grid xs={4} item>
                    <Card className={classes.leftCard}>
                        <CardContent>
                            <div>
                                <List
                                    aria-labelledby="nested-list-subheader"
                                    className={classes.principalRoot}
                                    component="nav"
                                    subheader={
                                        siteId === 'HUB' ?
                                            <ListSubheader component="div" id="nested-list-subheader">
                                                <div className={classes.iconQ}>
                                                    <ListItem button className={classes.justifyContentFlexEnd} onClick={() => addQuestion()} disabled={advance === 'LISTO' && questions.length === 0}>
                                                        <ListItemIcon className={classes.iconQ}>
                                                            <Icon style={{ fontSize: '20px', margin: '5%' }} type='plus-circle' theme='twoTone' />
                                                            <TextEvents
                                                                text='Nueva pregunta'
                                                                color='gray'
                                                                size='small'
                                                                weight='regular'
                                                            />
                                                        </ListItemIcon>

                                                    </ListItem>
                                                    <ListItem button className={classes.justifyContentFlexEnd} onClick={() => setModal2Visible(true)}>
                                                        <ListItemIcon className={classes.iconQ}>
                                                            <Icon type="file-excel" style={{ fontSize: '20px', margin: '5%', color: '#288504' }} />
                                                            <TextEvents
                                                                text='Cargar template'
                                                                color='gray'
                                                                size='small'
                                                                weight='regular'
                                                            />
                                                        </ListItemIcon>
                                                    </ListItem>
                                                    <Chip variant="outlined" color="primary" style={{ alignSelf: 'center' }} size="small" label={`Total: ${questions.length}`} />
                                                </div>
                                            </ListSubheader>
                                            :
                                            null
                                    }
                                >
                                </List>
                                <Divider />
                                <List dense={true}>
                                    <ListItem button disabled={!open} selected={!isTest} onClick={testStatus}>
                                        <ListItemIcon className={classes.itemText}>
                                            <IconButton edge="end" aria-label="delete">
                                                <Icon type="folder" />
                                            </IconButton>
                                        </ListItemIcon>
                                        <ListItemText primary={name} className={classes.itemText} />
                                        <ListItemSecondaryAction>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </List>
                                <Collapse in={open} timeout="auto" unmountOnExit className={classes.collapseScroll} >
                                    <List component="div" disablePadding>
                                        {questions.length > 0 ? generateQuestionList() : ''}
                                    </List>
                                </Collapse>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                {!isTest ? <Grid xs={8} item >
                    <Card className={classes.card}>
                        <CardContent>
                            <div className={classes.content}>
                                <Grid container direction="row">
                                    <Grid xs={6} item className={classes.gridSeparatorRight}>
                                        <TextInput
                                            value={folio}
                                            disabled
                                            text='Folio'
                                            mode='input'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            placeholder=""
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid xs={6} item className={classes.gridSeparatorLeft}>
                                        <TextInput
                                            disabled
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode="multiple"
                                            placeholder="Edición"
                                            value={estatus}
                                        >
                                        </TextInput>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextEvents
                                            text='Subdirección Origen'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <SubdirectionsContainer>
                                            {(params) => {
                                                return (
                                                    <Select
                                                        disabled
                                                        labelInValue
                                                        defaultValue={{ key: String(props.editParam.idSubdirection) }}
                                                        style={{ width: "100%" }}
                                                        onChange={(item) => {
                                                            findSubdir(params, item);
                                                        }}
                                                    >
                                                        {
                                                            params.subdirs.map((item) => {
                                                                return (
                                                                    <Select.Option key={String(item.idSubdirection)} value={String(item.idSubdirection)}>
                                                                        {item.subdirectionName}
                                                                    </Select.Option>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                )
                                            }}
                                        </SubdirectionsContainer>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextEvents
                                            text='Tipo de Capacitación'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            showSearch
                                            disabled={siteId !== 'HUB'}
                                            placeholder={'Selecciona Tipo de Capacitación'}
                                            //loading={isLoadTrainingSelect}
                                            value={idTraining}
                                            style={{ width: "100%" }}
                                            onChange={(item) => {
                                                setIdTraining(item);
                                                //setIdSystemSpecialty(undefined);
                                            }}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {optionTraining}
                                        </Select>
                                    </Grid>
                                    <Grid xs={12} item >
                                        <TextInput
                                            disabled={siteId !== 'HUB'}
                                            value={name}
                                            setValue={setName}
                                            text='Nombre'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                            mode='input'
                                            placeholder='Nombre'
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <TextEvents
                                    text='Descripción'
                                    color='darker'
                                    size='label'
                                    weight='medium'
                                />
                                <TextArea
                                    disabled={siteId !== 'HUB'}
                                    maxLength={1000}
                                    value={description}
                                    onChange={e => setDesc(e.target.value)}
                                    autosize={{ minRows: 5, maxRows: 6 }}
                                    placeholder='Descripción..'
                                />
                                <Grid xs={4} item>
                                    <TextEvents
                                        text={'Tiempo límite (minutos)'}
                                        color='darker'
                                        size='label'
                                        weight='medium'
                                    />
                                    <Input
                                        disabled={siteId !== 'HUB'}
                                        maxLength={4}
                                        value={time}
                                        placeholder='Tiempo límite'
                                        className={classes.inputSelect}
                                        onChange={onChangeNumber}
                                    />
                                </Grid>
                            </div>
                            <div className={classes.buttonsContainer}>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            variant='contained'
                                            type='primary'
                                            color='primary'
                                            onClick={showConfirm}
                                            disabled={(subdir.length === 0 && defaultSubdir === '') || name === ''}
                                        >
                                            Guardar
                                        </Button> : null
                                }
                                <Button
                                    type="danger" 
                                    ghost
                                    variant='contained'
                                    className={classes.button}
                                    onClick={() => {
                                        props.setTab('1')
                                        dispatch(clearTest());
                                        dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }))
                                    }}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </Grid> :
                    <Grid xs={8} item>
                        <Card className={classes.card}>
                            <CardContent>
                                <div className={classes.content}>
                                    <Grid container direction="row">
                                        <Grid xs={12} item className={classes.gridSeparatorTop}>
                                            {typeof questions !== 'undefined' ?

                                                <div>
                                                    {/* AQUI VA EL QUIZ */}
                                                    <Grid container direction="row">
                                                        <Grid xs={12} item className={classes.gridSeparatorRight}>
                                                            <TextEvents
                                                                text='Pregunta'
                                                                color='darker'
                                                                size='label'
                                                                weight='medium'
                                                            />
                                                            {createTextArea()}

                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction="row">
                                                        <Grid xs={3} item className={classes.gridSeparatorTop}>
                                                            {createTypeButtons()}
                                                        </Grid>
                                                        <Grid xs={9} item >
                                                            {addOptionButton()}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction="row">
                                                        {questions[selectedIndex].idQuestionType === 1 ?
                                                            <Grid xs={12} item >
                                                                {createOptions()}
                                                            </Grid> :
                                                            <Grid xs={12} item >
                                                                {createCheck(questions)}
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                    {/* AQUI CIERRA EL QUIZ */}
                                                </div> : ''}
                                        </Grid>
                                    </Grid>
                                </div>
                            </CardContent>
                        </Card>
                        <div className={classes.buttonsContainer}>
                            {
                                siteId === 'HUB' ?
                                    <Button
                                        type="primary"
                                        variant='contained'
                                        onClick={showSecondaryConfirm}
                                        disabled={questions.length <= 0 || !isReady || !isReadyOptions}
                                    >
                                        Guardar
                                    </Button>
                                    :
                                    null
                            }

                            <Button
                                type="danger" 
                                ghost
                                variant='contained'
                                className={classes.button}
                                onClick={() => props.setTab('1')}
                            >Cancelar</Button>
                        </div>
                    </Grid>}
            </Grid>

        </div>
    );
}